import * as React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import ListErrors from "../listErrors/ListErrors";
import { AppProps } from "../../stores/storeContract";
import "./Login.scss";
import Navigation from "../navigation/navigation";
import Announcement from "../announcement/Announcement";

@inject("userStore")
@(withRouter as any)
@observer
export default class Login extends React.Component<AppProps> {

	constructor(props: AppProps) {
		super(props);
	}

	componentWillUnmount() {
		this.props.userStore.resetFields();
	}

	handleUsernameChange = (e: any) => {
		this.props.userStore.setUserNameField(e.target.value);
	};

	handlePasswordChange = (e: any) => {
		this.props.userStore.setPasswordField(e.target.value);
	};

	handleSubmitForm = (e: any) => {
		e.preventDefault();
		this.props.userStore.login();
	};

	render() {
			
		const { userNameField, passwordField, errors, inProgress } = this.props.userStore;
		
		return (
			<div className="login-container">
				<Navigation {...this.props} />
				<Announcement {...this.props} />
				<div className={inProgress ? 'loader-container' : 'hidden'}>
					<div className={inProgress ? 'loader' : 'hidden'}></div>
				</div>
				<div className="login-floating-logo">M🌘onFinexScanner</div>

				<div className="login-center">
				
					<div className="row">
						
						<div className="col-md-4 offset-md-4 col-xs-12">
							<div className="row">
								<div className="col-md-12 col-xs-12">
									<h4 className="text-xs-center login-title">Sign In</h4>
									
									<form onSubmit={this.handleSubmitForm}>
										<fieldset>
											<fieldset className="form-group login-fieldset">
												<input
												className="form-control form-control-lg"
												type="text"
												placeholder="Username"
												value={userNameField}
												onChange={this.handleUsernameChange}
												/>
											</fieldset>

											<fieldset className="form-group login-fieldset">
												<input
												className="form-control form-control-lg"
												type="password"
												placeholder="Password"
												value={passwordField}
												onChange={this.handlePasswordChange}
												/>
											</fieldset>

											<ListErrors errors={errors} />

											<button
												className="btn btn-lg btn-login float-right login-btn"
												type="submit"
												disabled={inProgress}>
												Sign in
											</button>
										</fieldset>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}